module.exports = __webpack_public_path__ + "img/ClickForSound_25.ca733376.png";